export const config = {
  title: "Guardian",
  company_logo: "guardian.png",
  logo_placements: ["Left Chest", "Left Sleeve", "Right Sleeve", "Yoke"],
  show_image_preview: true,
  embroideries: {
    hat: ["Guardian"],
    mens: ["Guardian"],
    womens: ["Guardian"],
    accessory: ["Guardian"],
    customs: [],
    office: [],
    service: [],
    sales: [],
    detail: [],
    bodyshop: [],
    parts: [],
  },
  email_recipients: ["lbudbill@gpcorp.com", "lbudbell@comcast.net"],
  stores: [
    {
      name: "Guardian Products",
      address: "5575 Spalding Drive, Peachtree Corners, GA 30092",
      code: "GUAPRO",
    },
    {
      name: "Guardian Warehouse 1",
      address: "5575 Spalding Drive, Peachtree Corners, GA 30092",
      code: "GUAPR1",
    },
    {
      name: "Guardian Warehouse 2",
      address: "5575 Spalding Drive, Peachtree Corners, GA 30092",
      code: "GUAPR2",
    },
  ],
  bypass_codes: ["GUARDI"],
  server_hostname: "https://mxfj3q6m01.execute-api.us-east-1.amazonaws.com",
  account_reps: [{ name: "Louis Budbill", phone: "678-287-1659" }],
  route_prefix: "/guardian",
  paypal_not_supported: true,
  password: "GuardiaN",
};
